export const REMEMBERED_ACCOUNT_KEY = 'crm_remembered_account'

export function loadRememberedAccount () {
  try {
    return window.localStorage.getItem(REMEMBERED_ACCOUNT_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function saveRememberedAccount (account) {
  try {
    const value = (account || '').trim()
    if (value) {
      window.localStorage.setItem(REMEMBERED_ACCOUNT_KEY, value)
      return
    }

    window.localStorage.removeItem(REMEMBERED_ACCOUNT_KEY)
  } catch (e) {
    // Login must remain usable when browser storage is unavailable.
  }
}

export function clearRememberedAccount () {
  try {
    window.localStorage.removeItem(REMEMBERED_ACCOUNT_KEY)
  } catch (e) {
    // Login must remain usable when browser storage is unavailable.
  }
}
